<template>
  <div class="home">
    <!-- //头部 -->

    <navs></navs>
    <!-- banner -->
    <div class="banner">
      <div class="swiper-container backgroundfff">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="@/assets/img/banner1.png">
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/banner2.png">
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/banner3.png">
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/banner4.png">
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <!-- 我们能为您做什么？ -->
    <div class="what_we_do">
      <div class="all_box">
        <div class="what_we_do_title index_title ">
          <h3>What we do<span>我们能为您做什么</span></h3>
        </div>
        <div class="what_we_do_list">
          <div class="what_we_do_top">
            <div class="what_we_do_item">
              <div class="item_one">代理</div>
              <div class="item_two">The agent</div>
              <div class="item_three">代缴社保 · 代缴公积金 · 代发工资 · 代理招聘 · 猎头服务</div>
            </div>
            <div class="what_we_do_item" style="margin-left: 100px;">
              <div class="item_one">管理</div>
              <div class="item_two">management</div>
              <div class="item_three">劳务派遣 · 人才租赁 · 人才培训</div>
            </div>
          </div>
          <div class="what_we_do_bottom">
            <div class="what_we_do_item">
              <div class="item_one">外包</div>
              <div class="item_two">outsourcing</div>
              <div class="item_three">生产线外包 · 仓储物流外包 · 短期项目外包 · 临时工外包 · 物业服务 · 保洁服务 · 呼叫中心 · 代驾服务 · 薪酬规划 </div>
            </div>
          </div>
        </div>
        <div class="what_we_do_pic_list">
          <div class="what_we_do_pic_item">
            <div class="pic_item_top">
              <div class="pic_item_img_box">
                <img src="@/assets/img/wedo01.png">
              </div>
            </div>
            <div class="pic_item_text">
              <p><img src="@/assets/img/jiantou.png">做招聘<span>Doing the hiring</span></p>
            </div>
          </div>
          <div class="what_we_do_pic_item">
            <div class="pic_item_top">
              <div class="pic_item_img_box">
                <img src="@/assets/img/wedo02.png">
              </div>
            </div>
            <div class="pic_item_text">
              <p><img src="@/assets/img/jiantou.png">签合同<span>Sign the contract</span></p>
            </div>
          </div>
          <div class="what_we_do_pic_item">
            <div class="pic_item_top">
              <div class="pic_item_img_box">
                <img src="@/assets/img/wedo03.png">
              </div>
            </div>
            <div class="pic_item_text">
              <p><img src="@/assets/img/jiantou.png">买社保<span>Buy social security</span></p>
            </div>
          </div>
          <div class="what_we_do_pic_item">
            <div class="pic_item_top">
              <div class="pic_item_img_box">
                <img src="@/assets/img/wedo04.png">
              </div>
            </div>
            <div class="pic_item_text">
              <p><img src="@/assets/img/jiantou.png">发工资<span>Send salary</span></p>
            </div>
          </div>
          <div class="what_we_do_pic_item">
            <div class="pic_item_top">
              <div class="pic_item_img_box">
                <img src="@/assets/img/wedo05.png">
              </div>
            </div>
            <div class="pic_item_text">
              <p><img src="@/assets/img/jiantou.png">控风险<span>Control risk</span></p>
            </div>
          </div>
          <div class="what_we_do_pic_item">
            <div class="pic_item_top">
              <div class="pic_item_img_box">
                <img src="@/assets/img/wedo06.png">
              </div>
            </div>
            <div class="pic_item_text">
              <p><img src="@/assets/img/jiantou.png">优成本<span>To optimize the cost</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 社保计算器 -->
    <div class="sbjsq">
      <div class="all_box">
        <div class="sbjsq_box">
          <h3>社保计算器</h3>

          <el-select v-model="dataForm.sbId" placeholder="请输入内容" class="sbjsq_input" filterable>
            <el-option v-for="item in sbList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
          <div class="btn_box">
            <div class="chongzhi" @click="dataForm.sbId = ''">重置</div>
            <div class="lijichazhao" @click="getSbDetailSelect">立即查找</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻动态 -->
    <div class="new">
      <div class="all_box">
        <div class="new_box">
          <div class="new_title index_title">
            <h3>News<span>新闻动态</span></h3>
          </div>

          <div class="new_list_box">
            <div class="new_list_left" @click="goNewDetail(hotNewList.id)">
              <div class="new_left_pic">
                <img src="@/assets/img/new_pic.png">
              </div>
              <div class="new_left_text">
                <p>{{ hotNewList.updateDate }}</p>
                <h4>{{ hotNewList.title }}</h4>
              </div>
            </div>
            <div class="new_list_right">
              <div class="new_item" v-for="item in newList" @click="goNewDetail(item.id)">
                <h3>{{ item.title }}</h3>
                <p>{{ item.updateDate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <friend></friend>
    <foots></foots>
  </div>
</template>

<script>
import Swiper from "swiper"
import navs from '@/components/navs.vue'
import foots from '@/components/foots.vue'
import friend from '@/components/friend.vue'

export default {
  name: 'Home',
  data() {
    return {
      input: '',
      hotNewList: {},
      newList: [],
      sbList: [],
      dataForm: {
        sbId: ''
      }
    }
  },
  mounted() {
    this.myswiper()
    this.getHotNew()
    this.getSbList()
  },
  methods: {

    //跳转到社保查询页面并查询社保
    getSbDetailSelect() {
      if (this.dataForm.sbId) {
        this.$router.push({
          name: 'Programme',
          params: {
            sbId: this.dataForm.sbId,
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: '请输入关键字后查询。',
          type: 'warning'
        });
      }

    },

    //获取社保列表
    getSbList() {
      let data = {
        page: 1,
        limit: 10000,
        categoryId: '1628268343981793281',
      }
      this.$http.get(`/attract_investment/front/show/newsList`, {
        params: {
          ...data
        }
      }).then(({
        data: res
      }) => {
        this.sbList = res.list
      })
    },


    goNewDetail(id) {
      this.$router.push({
        path: '/newDetail',
        query: {
          id,
        }
      });
    },



    myswiper: function () {
      var swiper = new Swiper('.swiper-container', {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
        autoplay: {
          disableOnInteraction: false,
        },
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: true,
      });
    },
    //获取首页展示的热点资讯
    getHotNew() {
      let data = { 
        page: 1,
        limit: 5,
        categoryId: '1627852905191882754',
        orderField: "release_time",
        order: "desc"
      }
      this.$http.get(`/attract_investment/front/show/newsList`, {
        params: {
          ...data
        }
      }).then(({
        data: res
      }) => {
        this.newList = res.list
        this.hotNewList = res.list[0]
      })
    },
  },
  components: {
    navs,
    foots,
    friend
  }
}
</script>
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 700px;
}

.swiper-slide {
  width: 980px;
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  width: 100%;
  height: 700px;
}


.banner {
  width: 100%;
  padding-bottom: 130px;
}


.new_list_left {
  width: 49%;
  cursor: pointer;
}

.new_list_right {
  width: 49%;

  .new_item:first-child {
    padding-top: 0;
  }
}

.new_item {
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding: 30px 0;

  h3 {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    margin: 0;
  }

  p {
    font-size: 14px;
    color: #999999;
    margin: 0;
  }
}


.new {
  padding-top: 86px;
}

.pic_item_img_box {
  img {
    margin: 0 auto;
    box-shadow: -20px -1px 29px -5px rgba(0, 0, 0, 0.12);
  }
}

.pic_item_text {
  text-align: left;
  padding: 36px 0;

  p {
    margin: 0;
    font-size: 22px;
    color: #333;

    span {
      font-size: 16px;
      color: #666;
      margin-left: 16px;
    }
  }

  img {
    margin-bottom: -6px;
    margin-right: 16px;
    display: inline-block;
  }
}

.what_we_do_pic_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 50px;
}

.what_we_do_pic_item {
  width: 30%;
  padding-bottom: 50px;
}

.what_we_do_pic_item:hover {

  .pic_item_top {
    background: #FF9E29;
    transition: all .3s;
  }
}

.pic_item_top {
  background: #F6F6F6;
  border-radius: 16px;
  padding-top: 35px;
  transition: all .3s;
}


.btn_box {
  margin-top: 47px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .chongzhi {
    cursor: pointer;
    margin-right: 40px;
    width: 210px;
    height: 60px;
    line-height: 60px;
    border-radius: 100px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    border: 1px solid #fff;
  }

  .lijichazhao {
    cursor: pointer;
    border-radius: 100px;
    border: 1px solid #F08300;
    background: #F08300;
    width: 350px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    color: #fff;
  }
}

.what_we_do_title {
  padding-bottom: 25px;
  border-bottom: 1px solid #eee;
}

.what_we_do_list {
  padding-top: 33px;
}

.what_we_do_top {
  border-bottom: 1px solid #eee;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 30px 0;
}

.what_we_do_item {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.item_one {
  padding: 6px 14px;
  border: 1px solid #DFDFDF;
  background: #F3F3F3;
  color: #333;
  font-size: 14px;
  border-radius: 6px;

}

.item_two {
  font-size: 14px;
  color: #999999;
  margin: 0 25px;
  padding-top: 8px;
}

.item_three {
  font-size: 18px;
  color: #333;
  padding-top: 4px;
}

.what_we_do_bottom {
  border-bottom: 1px solid #eee;
  padding: 60px 0 30px;
}

.sbjsq {
  background: url(../assets/img/sbjsq_bg.png) center center no-repeat;
  background-size: 100% 100%;
  padding: 113px 0 142px;
}

.sbjsq_box {
  h3 {
    font-size: 36px;
    font-weight: 700;
    color: #fff;
    margin: 0;
    margin-bottom: 60px;
  }

  .sbjsq_input {
    width: 600px;
  }
}

.new_list_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 44px;
  margin-bottom: 120px;
}

.new_left_text {
  text-align: left;

  p {
    margin: 0;
    font-size: 16px;
    color: #999999;
    margin-top: 30px;
  }

  h4 {
    margin: 0;
    font-size: 20px;
    color: #333333;
    margin-top: 16px;
  }
}
</style>
<style lang="scss">
.banner {
  .swiper-pagination-bullet {
    background: #D9D9D9;
    margin: 0 10px !important;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: #F08300;
    position: relative;
  }

  .swiper-pagination-bullet-active:after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    left: -6px;
    top: -6px;
    background: none;
    border: 1px solid #f08300;
    border-radius: 18px;
  }
}

.all_box {
  width: 1400px;
  margin: 0 auto;
}

.index_title {
  text-align: left;
  position: relative;
  padding-left: 38px;

  h3 {
    margin: 0;
    font-size: 26px;
    color: #333;

    span {
      font-size: 18px;
      font-weight: 400;
      margin-left: 28px;
    }
  }

  :after {
    content: '';
    width: 16px;
    height: 16px;
    border-radius: 16px;
    background: #F08300;
    position: absolute;
    left: 0;
    top: 4px;
  }
}

.sbjsq_input {
  .el-input__inner {
    height: 60px;
    line-height: 60px;
  }
}

body {
  margin: 0;
}

img {
  display: block;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
</style>